import item from '../components/item/item'
import tabs from '../components/tabs/tabs'

export default {
  item,
  tabs
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/resources/components.js